import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { UserService, AppConfigSettings } from '@arc/arc-shared-frontend';
import { Store } from '@ngrx/store';
import 'whatwg-fetch';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ssoresult',
  templateUrl: './ssoresult.component.html',
  styleUrls: ['./ssoresult.component.scss']
})
export class SSOResultComponent implements OnInit, OnDestroy {
  tenantId = '';
  accessToken = '';
  token_type = '';
  logoutRedirectUrl = '';
  user: any = {};

  email;
  sub: Subscription;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private userService: UserService,
    private httpClient: HttpClient,
    private appSetting: AppConfigSettings
  ) { }

  ngOnInit() {
    this.accessToken = this.route.snapshot.queryParams['access_token'];
    this.logoutRedirectUrl = this.route.snapshot.queryParams[
      'logoutUrl'
    ];
    // this.router.params.subscribe(params => {
    //   this.accessToken = params['access_token'];
    // });

    //    this.userService.v1UsersProfileGet()

    this.sub = this.httpClient
      .get(this.appSetting.getconfig('userServiceUrl') + '/v1/users/profile', {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-Billtrust-Auth': this.accessToken
          // "Content-Type": "application/x-www-form-urlencoded",
        }
      })
      .subscribe(x => {
        this.user = x;
      });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
  logout($event) {
    fetch(
      this.appSetting.getconfig('authenticationServiceUrl') + '/v1/logout',
      {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify({ accessToken: this.accessToken })
      }
    )
      .then(response => {
        if (this.logoutRedirectUrl) {
          this.document.location.href = this.logoutRedirectUrl;
        } else {
          this.router.navigateByUrl('/login');
        }
      })
      .catch(error => {
        if (this.logoutRedirectUrl) {
          this.document.location.href = this.logoutRedirectUrl;
        } else {
          this.router.navigateByUrl('/login');
        }
      });
  }
}
